document.addEventListener('DOMContentLoaded', () => {
  const applyFilter = (checkboxSelector, groupSelector, attrName, displayWhenMatch = 'block') => {
    const boxes = Array.from(document.querySelectorAll(checkboxSelector));
    const groups = Array.from(document.querySelectorAll(groupSelector));

    if (!boxes.length || !groups.length) return;

    const run = () => {
      const selected = new Set();
      for (const cb of boxes) if (cb.checked) selected.add(cb.value);

      for (const el of groups) {
        const key = el.getAttribute(attrName);
        el.style.display = selected.has(key) ? displayWhenMatch : 'none';
      }
    };

    // One listener per checkbox (still light, but less code than before)
    for (const cb of boxes) cb.addEventListener('change', run);

    run(); // initial
  };

  applyFilter('.type-filter', '.accessory-group', 'data-type', 'block');
  applyFilter('.camera-family-filter', '.camera-group', 'data-family', 'block');
});
